module.exports = require('./helpers/bundle-url').getBundleURL('92UBU') + "dark-theme-onboarding.e782df86.svg";